import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import logo from './logo.svg';
import Navbar from './Navbar';
import Banner from './Banner';
import Maquina from './Maquina';
import Produtos from './Produtos';
import Testemonial from './Testemomial';
import Numeros from './Numeros';
import Assistencia from './Assistencia';
import Whatsapp from './Whatsapp';
import Footer from './Footer';
import Showcase from './Showcase';
import Equipamento from './Equipamento';
import Contato from './Contato';
import Sobre from './Sobre';
import NotFound from "./NotFound";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={
          <>
            <Banner />
            <Numeros />
            <Produtos />
            <Maquina />
            <Testemonial />
            <Assistencia />
            <Footer />
            <Whatsapp />
          </>
        } />
        <Route path="/produtos" element={<Showcase />} />
        <Route path="/equipamento/:nome" element={<Equipamento />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/sobre" element={<Sobre />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
